import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { TabHeaderView } from "kea-react/dist/tabs/tabHeader";

type Entity = models.FiltroViajeZE;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    session: models.Session;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {};
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class ViajeZEFiltroComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        
        const getField = this.getField;
        //const Chofer = getField(selectores.ChoferZE);
        const Vehiculo = getField(selectores.VehiculoZE);
        const Sucursal = getField(selectores.Sucursal);
        const Number = getField(kea.Number);
        const Date = getField(kea.DateTime);
        const Proveedor = getField(selectores.UsuarioZEByUserRol);

        const EsProveedor = this.props.session.IdUsuarioZE != null && this.props.session.IdChoferZE == null
        const EsChofer = this.props.session.IdUsuarioZE != null && this.props.session.IdChoferZE != null

        if (EsProveedor) {
            this.props.value.IdProveedor = this.props.session.IdUsuarioZE
        }
        if (EsChofer) {
            this.props.value.IdProveedor = this.props.session.IdUsuarioZE
            this.props.value.IdChofer = this.props.session.IdChoferZE
        }
        
        const validarChoferId = this.props.value.IdChofer === undefined || this.props.value.IdChofer == null? 0 : this.props.value.IdChofer
        const validarProveedorId = this.props.value.IdProveedor === undefined || this.props.value.IdProveedor == null? 0 : this.props.value.IdProveedor

        const Vehiculo2 = getField(selectores.VehiculoByChoferId( validarChoferId ));
        const Chofer = getField(selectores.ChoferZEByUserZE(validarProveedorId));

        const { value } = this.props;
        return (
            <div>
                {kea.autogrid(3, [
                    <Proveedor field="IdProveedor" label="Proveedor" readonly={EsProveedor || EsChofer} />,

                    <Chofer field="IdChofer" label="Chofer" readonly={EsChofer} />,
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <Number field="Folio" label="Folio" />,
                    <Date field="FechaCreacionInicio" label="Fecha creación (inicio)" />,
                    <Date field="FechaCreacionFinal" label="Fecha creación (final)" />,
                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesZE/list/filtro.tsx